module.exports = __webpack_public_path__ + "img/30.ef91d002.jpg";